import React, { useState } from 'react';
import './Hero.css';

const Hero = () => {
  const [imageError, setImageError] = useState(false);

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <span>🚀 New Platform</span>
          </div>
          <h1 className="hero-title">
            Find Your Dream Job, Anywhere.
            <span className="gradient-text"> Download the JobFinder App.</span>
          </h1>
          <p className="hero-description">
            Connect students, developers, DevOps engineers, data scientists, and ML engineers 
            with top companies. Discover internships, full-time positions, and contract opportunities 
            all in one place. All job searching happens in the app.
          </p>
          <div className="hero-badges">
            <a 
              href="https://play.google.com/store/apps" 
              className="hero-badge-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get it on Google Play"
            >
              <img 
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" 
                alt="Get it on Google Play"
                className="hero-badge-image"
              />
            </a>
            <a 
              href="https://www.apple.com/app-store/" 
              className="hero-badge-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download on the App Store"
            >
              <img 
                src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1276560000" 
                alt="Download on the App Store"
                className="hero-badge-image"
              />
            </a>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <div className="stat-number">10K+</div>
              <div className="stat-label">Active Jobs</div>
            </div>
            <div className="stat">
              <div className="stat-number">5K+</div>
              <div className="stat-label">Companies</div>
            </div>
            <div className="stat">
              <div className="stat-number">50K+</div>
              <div className="stat-label">Users</div>
            </div>
          </div>
        </div>
        <div className="hero-image">
          <div className="phone-mockup">
            <div className="phone-screen">
              {!imageError ? (
                <img 
                  src="/phone-screenshot.png" 
                  alt="Joby App Screenshot" 
                  className="phone-screenshot"
                  onError={() => setImageError(true)}
                />
              ) : (
                <div className="mockup-content">
                  <div className="mockup-header"></div>
                  <div className="mockup-job-card"></div>
                  <div className="mockup-job-card"></div>
                  <div className="mockup-job-card"></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

